// "babel-polyfill": "^6.26.0",
// import 'babel-polyfill';
let top = {};

top = {

};

// document.addEventListener('DOMContentLoaded', () => {
// });

window.addEventListener('load', () => {
  if (location.hash !== '#noanimation') {
    top.move_fish();
  }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/top.js
// module id = 2
// module chunks = 1